import clsx from 'clsx';
import type { Ref } from 'react';

import MailVariableEditor, { type MailVariableEditorHandle } from './MailVariableEditor';

type MailSubjectBodyFieldsProps = {
  subject: string;
  onSubjectChange: (value: string) => void;
  body: string;
  onBodyChange: (value: string) => void;
  bodyEditorRef: Ref<MailVariableEditorHandle>;
  disabled?: boolean;
  className?: string;
};

export default function MailSubjectBodyFields({
  subject,
  onSubjectChange,
  body,
  onBodyChange,
  bodyEditorRef,
  disabled = false,
  className,
}: MailSubjectBodyFieldsProps) {
  return (
    <div
      className={clsx(
        'flex flex-col overflow-hidden rounded-sm border border-solid border-border bg-white focus-within:border-primary',
        className
      )}
    >
      <input
        aria-label="件名"
        placeholder="件名"
        value={subject}
        onChange={(event) => onSubjectChange(event.target.value)}
        disabled={disabled}
        className="h-[54px] w-full shrink-0 border-x-0 border-t-0 border-b border-solid border-border bg-white px-sm text-body-sm text-main outline-hidden placeholder:text-sub"
      />
      <MailVariableEditor
        ref={bodyEditorRef}
        aria-label="本文"
        placeholder="本文"
        value={body}
        onChange={onBodyChange}
        disabled={disabled}
        className="min-h-0 flex-1"
      />
    </div>
  );
}
